// import React, { useState, useRef, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   ListItem,
//   ListItemText,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Radio,
//   Chip,
// } from "@mui/material";
// import CloseIcon from "@material-ui/icons/Close";
// import DeleteIcon from "@mui/icons-material/Delete";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import PauseIcon from "@mui/icons-material/Pause";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import ArticleIcon from "@mui/icons-material/Article";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import Tooltip from "@mui/material/Tooltip";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
// import { BACKEND_BASE_URL, CAPTURE_BACKEND_URL } from "../config";

// import { useLocation } from "react-router-dom";
// // ------------------- API Endpoints ------------------- //
// const API_GET_EVENTS = `${BACKEND_BASE_URL}/api/capture/capture-events/`;
// // const API_GET_EVENT = (id) =>
// //   `${BACKEND_BASE_URL}/api/capture/capture-events/${id}/`;

// const API_AUDIO_UPLOAD = `${BACKEND_BASE_URL}/api/capture/audio/upload/`;
// const API_AUDIO_LIST = (eventId) =>
//   `${BACKEND_BASE_URL}/api/capture/audio/list/${eventId}/`;
// const API_AUDIO_PROCESS = (pk) =>
//   `${BACKEND_BASE_URL}/api/capture/audio/process/${pk}/`;
// const API_DELETE_EVENT = (id) =>
//   `${BACKEND_BASE_URL}/api/capture/capture-events/delete/${id}/`;

// const getAudioUrl = (file) => {
//   if (file.startsWith("/")) {
//     return `${BACKEND_BASE_URL.replace(/\/$/, "")}${file}`;
//   }
//   return file;
// };

// const CaptureEvents = () => {
//   const [events, setEvents] = useState([]);
//   const [loadingEvents, setLoadingEvents] = useState(true);

//   const [audioModalOpen, setAudioModalOpen] = useState(false);
//   const [selectedAudioEvent, setSelectedAudioEvent] = useState(null);
//   const [audioList, setAudioList] = useState([]);
//   const [selectedAudioIndex, setSelectedAudioIndex] = useState(null);
//   const audioRef = useRef();
//   const [isPlayingIndex, setIsPlayingIndex] = useState(null);

//   // const [uploading, setUploading] = useState(false);
//   const [processingLoading, setProcessingLoading] = useState(false);
//   // const [uploadSuccess, setUploadSuccess] = useState(false);

//   const [transcriptModalOpen, setTranscriptModalOpen] = useState(false);
//   const [selectedTranscriptEvent, setSelectedTranscriptEvent] = useState(null);
//   const [transcript, setTranscript] = useState("");
//   const [loadingTranscript, setLoadingTranscript] = useState(false);

//   const [deleteLoading, setDeleteLoading] = useState(null);

//   // Add these new state variables for Audio Summary Modal
//   const [summaryModalOpen, setSummaryModalOpen] = useState(false);
//   const [selectedSummaryEvent, setSelectedSummaryEvent] = useState(null);
//   const [summaryData, setSummaryData] = useState([]);
//   const [loadingSummary, setLoadingSummary] = useState(false);
//   const [summarySearchQuery, setSummarySearchQuery] = useState("");
//   const [summarySortKey, setSummarySortKey] = useState("");
//   const [filteredSummaryData, setFilteredSummaryData] = useState([]);
//   // Store which audio is selected for each event
//   const [selectedAudios, setSelectedAudios] = useState({}); // { eventId: audioId }
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [confirmDialogMessage, setConfirmDialogMessage] = useState("");
//   const [confirmDialogAction, setConfirmDialogAction] = useState(() => () => { });

//   // ======================================================

//   // =======================municipality Id===========================
//   const location = useLocation();
//   // Extract municipalityId from query param
//   const params = new URLSearchParams(location.search);
//   const municipalityId = params.get("municipalityId");

//   // =========================================
//   const getToken = () => localStorage.getItem("authToken");
//   const getHeaders = () => ({
//     Authorization: `Bearer ${getToken()}`,
//   });

//   const fetchEvents = async () => {
//     setLoadingEvents(true);
//     try {
//       const token = localStorage.getItem("authToken");
//       // Add municipalityId to URL as query param if present
//       let url = API_GET_EVENTS;
//       if (municipalityId) {
//         const separator = url.includes("?") ? "&" : "?";
//         url = url + `${separator}municipality=${encodeURIComponent(municipalityId)}`;
//       }
//       const res = await fetch(url, { headers: getHeaders() });
//       if (res.ok) {
//         const data = await res.json();
//         if (Array.isArray(data)) setEvents(data);
//         else if (Array.isArray(data.results)) setEvents(data.results);
//         else if (Array.isArray(data.data)) setEvents(data.data);
//         else setEvents([]);
//       } else {
//         toast.error("Failed to fetch events.");
//         setEvents([]);
//       }
//     } catch (err) {
//       console.error("Error fetching events:", err);
//       toast.error("Error fetching events.");
//       setEvents([]);
//     }
//     setLoadingEvents(false);
//   };


//   useEffect(() => {
//     fetchEvents();
//   }, []);

//   const fetchAudioFiles = async (eventId) => {
//     try {
//       const response = await fetch(API_AUDIO_LIST(eventId), {
//         headers: getHeaders(),
//       });
//       if (response.ok) {
//         const data = await response.json();
//         if (Array.isArray(data.data)) setAudioList(data.data);
//         else if (Array.isArray(data)) setAudioList(data);
//         else setAudioList([]);
//         setSelectedAudioIndex(null);
//       } else {
//         toast.error("Failed to fetch audio files.");
//         setAudioList([]);
//       }
//     } catch (err) {
//       console.error("Error fetching audio list:", err);
//       toast.error("Error fetching audio files.");
//       setAudioList([]);
//     }
//   };

//   const handlePlayPause = (index) => {
//     if (audioRef.current) {
//       if (isPlayingIndex === index) {
//         audioRef.current.pause();
//         setIsPlayingIndex(null);
//       } else {
//         audioRef.current.src = getAudioUrl(audioList[index].file);
//         const playPromise = audioRef.current.play();
//         if (playPromise !== undefined) {
//           playPromise
//             .then(() => {
//               setIsPlayingIndex(index);
//             })
//             .catch((error) => {
//               console.error("Audio play failed:", error);
//               toast.error("Failed to play audio.");
//               setIsPlayingIndex(null);
//             });
//         } else {
//           setIsPlayingIndex(index);
//         }
//       }
//     }
//   };

//   const handleAudioEnded = () => setIsPlayingIndex(null);

//   const handleViewAudio = (event) => {
//     setSelectedAudioEvent(event);
//     fetchAudioFiles(event.id);
//     setIsPlayingIndex(null);
//     setAudioModalOpen(true);
//   };


//   const handleProcessAudio = async (eventId, audioId) => {
//     if (!audioId) return;

//     setProcessingLoading(true);
//     setTranscriptModalOpen(true);
//     setLoadingTranscript(true);
//     setTranscript("Processing transcript... ⏳");

//     try {
//       const response = await fetch(API_AUDIO_PROCESS(audioId), {
//         method: "POST",
//         headers: getHeaders(),
//       });
//       const data = await response.json();

//       if (response.ok && data.status === "started") {
//         // Start polling for transcript
//         await pollTranscript(eventId, audioId);
//       } else if (data.status === "exists") {
//         toast.info("Transcript already exists.");
//         await handleViewTranscript(eventId, audioId);
//       } else {
//         toast.error(data.message || "Failed to start processing.");
//         setTranscript("Failed to process transcript.");
//         setTranscriptModalOpen(false);
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Error starting processing.");
//       setTranscript("Error processing transcript.");
//       setTranscriptModalOpen(false);
//     } finally {
//       setProcessingLoading(false);
//     }
//   };

//   // Polling function
//   const pollTranscript = async (eventId, mediaId, interval = 3000, maxAttempts = 20) => {
//     let attempts = 0;

//     const poll = async () => {
//       if (attempts >= maxAttempts) {
//         // setTranscript("Transcript processing timed out.");
//         setTranscript("Transcript is taking longer than expected and started in background. Please check back later.");
//         setLoadingTranscript(false);
//         return;
//       }

//       try {
//         const res = await fetch(
//           `${BACKEND_BASE_URL}/api/capture/transcripts/${eventId}/${mediaId}/`,
//           { headers: getHeaders() }
//         );
//         if (res.ok) {
//           const data = await res.json();
//           if (data.data?.raw_text) {
//             setTranscript(data.data.raw_text);
//             setLoadingTranscript(false);
//             await fetchEvents();
//           } else {
//             attempts++;
//             setTimeout(poll, interval);
//           }
//         } else {
//           attempts++;
//           setTimeout(poll, interval);
//         }
//       } catch (err) {
//         console.error("Error polling transcript:", err);
//         attempts++;
//         setTimeout(poll, interval);
//       }
//     };

//     poll();
//   };




//   const handleAudioClose = () => {
//     if (audioRef.current) audioRef.current.pause();
//     setIsPlayingIndex(null);
//     setAudioModalOpen(false);
//     setSelectedAudioEvent(null);
//     setAudioList([]);
//     setSelectedAudioIndex(null);
//   };

//   const handleViewTranscript = async (eventId, mediaId) => {
//     setLoadingTranscript(true);
//     try {
//       const res = await fetch(
//         `${BACKEND_BASE_URL}/api/capture/transcripts/${eventId}/${mediaId}/`,
//         { headers: getHeaders() }
//       );
//       if (res.ok) {
//         const data = await res.json();
//         setTranscript(data.data?.raw_text || "No transcript found.");
//       } else {
//         toast.error("Failed to fetch transcript.");
//         setTranscript("Failed to fetch transcript");
//       }

//     } catch (err) {
//       console.error("Error fetching transcript:", err);
//       toast.error("Error fetching transcript.");
//       setTranscript("Error fetching transcript.");
//     }
//     setLoadingTranscript(false);
//   };


//   const handleTranscriptClose = () => {
//     setTranscriptModalOpen(false);
//     setSelectedTranscriptEvent(null);
//     setTranscript("");
//   };

//   const showConfirmDialog = (message, onConfirm) => {
//     setConfirmDialogMessage(message);
//     setConfirmDialogAction(() => onConfirm); // save callback
//     setConfirmDialogOpen(true);
//   };

//   const handleConfirmDialogClose = () => {
//     setConfirmDialogOpen(false);
//     setConfirmDialogMessage("");
//     setConfirmDialogAction(() => () => { });
//   };

//   const handleConfirmDialogConfirm = () => {
//     confirmDialogAction();
//     handleConfirmDialogClose();
//   };

//   const handleDelete = (id) => {
//     showConfirmDialog("Are you sure you want to delete this event?", () => handleDeleteConfirmed(id));
//   };

//   const handleDeleteConfirmed = async (id) => {
//     setDeleteLoading(id);
//     try {
//       const res = await fetch(API_DELETE_EVENT(id), {
//         method: "DELETE",
//         headers: getHeaders(),
//       });
//       if (res.ok) {
//         toast.success("Event deleted successfully.");
//         setEvents((prev) => prev.filter((ev) => ev.id !== id));
//       } else {
//         toast.error("Failed to delete event.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Error deleting event.");
//     }
//     setDeleteLoading(null);
//   };



//   // ==========================================================

//   // Add these functions in your CaptureEvents component

//   // Replace the existing handleViewSummary function with this updated version
//   const handleViewSummary = async (eventId, mediaId) => {
//     // Find the selected event to get its details
//     const selectedEvent = events.find(ev => ev.id === eventId);
//     if (!selectedEvent) {
//       toast.error("Event not found.");
//       return;
//     }

//     // Find the selected media to get transcript ID
//     const selectedMedia = selectedEvent.media?.find(m => m.id === mediaId);
//     if (!selectedMedia || !selectedMedia.transcripts || selectedMedia.transcripts.length === 0) {
//       toast.error("No transcript found for selected audio.");
//       return;
//     }

//     // Get the transcript ID from the selected media
//     const transcriptId = selectedMedia.transcripts[0].id;

//     setSelectedSummaryEvent(selectedEvent);
//     setSummaryModalOpen(true);
//     setLoadingSummary(true);

//     try {
//       const response = await fetch(`${BACKEND_BASE_URL}/api/capture/audio/summary/generate/`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${getToken()}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           capture_transcript_id: transcriptId,
//           event_id: eventId,
//           state: selectedEvent.state || '',
//           county: selectedEvent.county || '',
//           municipality: selectedEvent.municipality_name || ''
//         })
//       });

//       if (response.ok) {
//         const data = await response.json();
//         if (data.status === "completed") {
//           const summaries = data.summaries || [];
//           setSummaryData(summaries);
//           setFilteredSummaryData(summaries);
//           toast.success("Summary generated successfully!");
//           fetchEvents();
//         } else {
//           toast.error(data.message || "Failed to generate audio summary");
//           setSummaryData([]);
//           setFilteredSummaryData([]);
//         }
//       } else {
//         const errorData = await response.json();
//         toast.error(errorData.message || "Failed to generate audio summary");
//         setSummaryData([]);
//         setFilteredSummaryData([]);
//       }
//     } catch (error) {
//       console.error("Error generating audio summary:", error);
//       toast.error("Error generating audio summary");
//       setSummaryData([]);
//       setFilteredSummaryData([]);
//     } finally {
//       setLoadingSummary(false);
//     }
//   };



//   const handleSummaryClose = () => {
//     setSummaryModalOpen(false);
//     setSelectedSummaryEvent(null);
//     setSummaryData([]);
//     setFilteredSummaryData([]);
//     setSummarySearchQuery("");
//     setSummarySortKey("");
//   };

//   const handleSummarySortChange = (event) => {
//     const key = event.target.value;
//     setSummarySortKey(key);
//     const sortedData = [...filteredSummaryData].sort((a, b) => {
//       if (key === "entry_date_desc") {
//         return new Date(b.inserted_at) - new Date(a.inserted_at);
//       } else if (key === "entry_date_asc") {
//         return new Date(a.inserted_at) - new Date(b.inserted_at);
//       } else if (key === "alphabetical_asc") {
//         return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
//       } else if (key === "alphabetical_desc") {
//         return b.name.toLowerCase().localeCompare(a.name.toLowerCase());
//       }
//       return 0;
//     });
//     setFilteredSummaryData(sortedData);
//   };

//   const handleSummarySearchChange = (event) => {
//     const query = event.target.value.toLowerCase();
//     setSummarySearchQuery(query);
//   };

//   const handleSummarySearch = () => {
//     const filtered = summaryData.filter(item =>
//       item.name.toLowerCase().includes(summarySearchQuery) ||
//       item.type.toLowerCase().includes(summarySearchQuery) ||
//       (item.categories || []).some(cat =>
//         cat.name.toLowerCase().includes(summarySearchQuery)
//       ) ||
//       item.short_summary.toLowerCase().includes(summarySearchQuery)
//     );
//     setFilteredSummaryData(filtered);
//   };


//   const getCategoryColor = (category) => {
//     const colors = {
//       'Public Health': '#4CAF50',
//       'Education': '#2196F3',
//       'Environment': '#8BC34A',
//       'Infrastructure': '#FF9800',
//       'Finance': '#9C27B0',
//       'Urban Planning': '#00BCD4',
//       'Governance': '#F44336',
//       'Public Safety': '#795548',
//       'Community': '#607D8B',
//       'miscellaneous': '#9E9E9E'
//     };
//     return colors[category] || '#9E9E9E';
//   };
//   // ========================================================================
//   const handleListItemClick = (index) => {
//     setSelectedAudioIndex(index);
//   };
//   const getEventStatus = (event) => {
//     if (!event.media || event.media.length === 0) {
//       return { status: "no-media", label: "No Media", color: "#e0e0e0" };
//     }

//     // Collect all transcript statuses from all media files
//     const allStatuses = [];
//     let hasEmptyTranscripts = false;

//     event.media.forEach((media) => {
//       if (media.transcripts && media.transcripts.length > 0) {
//         media.transcripts.forEach((transcript) => {
//           allStatuses.push(transcript.stt_status);
//         });
//       } else {
//         // If transcripts array is empty, mark as "not started"
//         hasEmptyTranscripts = true;
//       }
//     });

//     // If all media have empty transcripts
//     if (allStatuses.length === 0 && hasEmptyTranscripts) {
//       return { status: "not-started", label: "Not Started", color: "default" };
//     }

//     // If no transcripts found, all media are just uploaded
//     if (allStatuses.length === 0) {
//       return { status: "uploaded", label: "Uploaded", color: "default" };
//     }

//     // Priority logic: processing > failed > completed > uploaded
//     if (allStatuses.includes("processing")) {
//       return { status: "processing", label: "Processing", color: "warning" };
//     }

//     if (allStatuses.includes("failed")) {
//       return { status: "failed", label: "Failed", color: "error" };
//     }

//     if (allStatuses.every((s) => s === "completed")) {
//       return { status: "completed", label: "Completed", color: "success" };
//     }

//     // Mixed states - show processing if any are still processing
//     return { status: "processing", label: "Processing", color: "warning" };
//   };

//   // Helper function to get status of a specific audio file
//   const getAudioFileStatus = (media) => {
//     if (!media.transcripts || media.transcripts.length === 0) {
//       return { status: "not-started", label: "Not Started", color: "info" };
//     }

//     const transcript = media.transcripts[0];
//     const sttStatus = transcript.stt_status;
//     console.log(sttStatus)

//     switch (sttStatus) {
//       case "processing":
//         return { status: "processing", label: "Processing", color: "warning" };
//       case "completed":
//         return { status: "completed", label: "Completed", color: "success" };
//       case "failed":
//         return { status: "failed", label: "Failed", color: "error" };
//       default:
//         return { status: "uploaded", label: "Uploaded", color: "default" };
//     }
//   };

//   return (
//     <Box sx={{ p: 4 }}>
//       <ToastContainer position="top-right" autoClose={3000} />
//       <Typography variant="h5" gutterBottom>
//         Capture Events
//       </Typography>

//       {loadingEvents ? (
//         <CircularProgress />
//       ) : (
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead sx={{ backgroundColor: "#1E2A78" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "#fff" }}>S.no</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Title</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Meeting Type</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Municipality</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Date</TableCell>
//                 {/* <TableCell sx={{ color: "#fff" }}>Created At</TableCell> */}
//                 {/* <TableCell sx={{ color: "#fff" }}>Status</TableCell> */}
//                 <TableCell sx={{ color: "#fff" }}>Select Audio</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Actions</TableCell>
//                 <TableCell sx={{ color: "#fff" }}>Selected Transcript Status</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {events.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={8} align="center" style={{ fontStyle: 'italic', color: '#666' }}>
//                     No events available.
//                   </TableCell>
//                 </TableRow>
//               )
//                 : (events.map((ev, idx) => (
//                   <TableRow key={ev.id}>
//                     <TableCell>{idx + 1}</TableCell>
//                     <TableCell>{ev.title}</TableCell>
//                     <TableCell>{ev.meeting_type_name || ev.meeting_type}</TableCell>
//                     <TableCell>{ev.municipality_name}</TableCell>
//                     <TableCell>
//                       {ev.date}
//                     </TableCell>
//                     {/* <TableCell>{ev.created_at ? new Date(ev.created_at).toLocaleString() : "-"}</TableCell> */}
//                     {/* <TableCell>{getEventStatus(ev)}</TableCell> */}
//                     {/* 🔽 HERE you add the new dropdown cell */}
//                     <TableCell>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           displayEmpty
//                           value={selectedAudios[ev.id] || ""}
//                           onChange={(e) =>
//                             setSelectedAudios((prev) => ({ ...prev, [ev.id]: e.target.value }))
//                           }
//                           renderValue={(value) => {
//                             if (!value) return "Select an audio";
//                             const selected = ev.media?.find((m) => m.id === value);
//                             return selected ? selected.caption || `Audio ${selected.id}` : "Select an audio";
//                           }}
//                         >
//                           {(ev.media || []).map((audio) => (
//                             <MenuItem key={audio.id} value={audio.id}>
//                               {audio.caption || audio.event_title || `Audio ${audio.id}`}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </TableCell>

//                     <TableCell>
//                       {/* Generate Transcript Button */}
//                       <Tooltip title="Generate Transcript">
//                         <Button
//                           size="small"
//                           variant="outlined"
//                           sx={{ mr: 1 }}
//                           onClick={() => {
//                             if (!selectedAudios[ev.id]) {
//                               toast.warning("Please select an audio from dropdown");
//                               return;
//                             }
//                             handleProcessAudio(ev.id, selectedAudios[ev.id]);
//                           }}
//                         >
//                           Generate Transcript
//                         </Button>
//                       </Tooltip>

//                       {/* Generate Summary Button */}
//                       <Tooltip title="Generate Summary">
//                         <Button
//                           size="small"
//                           variant="outlined"
//                           sx={{ mr: 1 }}
//                           onClick={() => {
//                             if (!selectedAudios[ev.id]) {
//                               toast.warning("Please select an audio from dropdown");
//                               return;
//                             }
//                             handleViewSummary(ev.id, selectedAudios[ev.id]);
//                           }}
//                         >
//                           Generate Summary
//                         </Button>
//                       </Tooltip>

//                       {/* View Audio Icon */}
//                       <Tooltip title="View Audio">
//                         <IconButton
//                           color="primary"
//                           onClick={() => handleViewAudio(ev)}
//                         >
//                           <VisibilityIcon />
//                         </IconButton>
//                       </Tooltip>

//                       {/* Delete Icon */}
//                       <Tooltip title="Delete Event">
//                         <IconButton
//                           color="error"
//                           onClick={() => handleDelete(ev.id)}
//                           disabled={deleteLoading === ev.id}
//                         >
//                           <DeleteIcon />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                     {/* <TableCell>
//                       {(() => {
//                         const statusInfo = getEventStatus(ev);
//                         return (
//                           <Chip
//                             label={statusInfo.label}
//                             color={statusInfo.color}
//                             size="small"
//                           />
//                         );
//                       })()}
//                     </TableCell> */}
//                     <TableCell>
//                       {(() => {
//                         const selectedAudioId = selectedAudios[ev.id];
//                         let statusInfo;

//                         if (selectedAudioId) {
//                           // If audio is selected, show status of that specific audio
//                           const selectedMedia = ev.media?.find((m) => m.id === selectedAudioId);
//                           statusInfo = selectedMedia ? getAudioFileStatus(selectedMedia) : getEventStatus(ev);
//                         } else {
//                           // If no audio selected, show overall event status
//                           statusInfo = getEventStatus(ev);
//                           // statusInfo= "not selected any transcript"
//                         }

//                         return (
//                           <Chip
//                             label={statusInfo.label}
//                             color={statusInfo.color}
//                             size="small"
//                           />
//                         );
//                       })()}
//                     </TableCell>
//                   </TableRow>
//                 )))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}

//       {/* Audio Modal */}
//       <Dialog open={audioModalOpen} onClose={handleAudioClose} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           🎵 Audio for "{selectedAudioEvent?.title}"
//           <Button
//             onClick={handleAudioClose}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               textTransform: "none",
//             }}
//           >
//             CLOSE
//           </Button>
//         </DialogTitle>
//         <DialogContent dividers>
//           {/* No audio message */}
//           {Array.isArray(audioList) && audioList.length === 0 && (
//             <Typography sx={{ textAlign: "center", color: "text.secondary", py: 2 }}>
//               No audio files found for this event.
//             </Typography>
//           )}

//           {/* Audio list */}
//           {Array.isArray(audioList) &&
//             audioList.map((audio, i) => {
//               // Transcript status (fallback = "uploaded")
//               const transcriptStatus =
//                 audio.transcripts?.length > 0
//                   ? audio.transcripts[0].stt_status
//                   : "uploaded";

//               const getStatusColor = (status) => {
//                 switch (status) {
//                   case "uploaded":
//                     return "default";
//                   case "processing":
//                     return "warning";
//                   case "failed":
//                     return "error";
//                   case "completed":
//                     return "success";
//                   default:
//                     return "default";
//                 }
//               };

//               return (
//                 <ListItem
//                   key={audio.id}
//                   onClick={() => handleListItemClick(i)} // keep selection logic
//                   sx={{
//                     border: selectedAudioIndex === i ? "2px solid #1976d2" : "1px solid #ddd",
//                     borderRadius: 2,
//                     mb: 2,
//                     p: 2,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     transition: "0.2s",
//                     "&:hover": {
//                       backgroundColor: "rgba(25, 118, 210, 0.04)",
//                       cursor: "pointer",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={audio.caption || audio.event_title || `Audio ${i + 1}`}
//                     secondary={`Uploaded at: ${new Date(audio.uploaded_at).toLocaleString()}`}
//                     primaryTypographyProps={{
//                       fontWeight: selectedAudioIndex === i ? "bold" : "normal",
//                     }}
//                   />

//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     {/* Transcript Status Chip */}
//                     <Chip
//                       label={transcriptStatus.charAt(0).toUpperCase() + transcriptStatus.slice(1)}
//                       color={getStatusColor(transcriptStatus)}
//                       size="small"
//                     />

//                     {/* Play / Pause Button */}
//                     <IconButton
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handlePlayPause(i);
//                       }}
//                     >
//                       {isPlayingIndex === i ? <PauseIcon /> : <PlayArrowIcon />}
//                     </IconButton>
//                     Status: { }
//                   </Box>
//                 </ListItem>
//               );
//             })}

//           {/* Inline audio player */}
//           {selectedAudioIndex !== null && (
//             <Box sx={{ mt: 2 }}>
//               <audio
//                 ref={audioRef}
//                 onEnded={handleAudioEnded}
//                 style={{ width: "100%", borderRadius: 8 }}
//                 controls
//               />
//             </Box>
//           )}

//           {/* Process Button */}
//           <Button
//             fullWidth
//             variant="contained"
//             sx={{ mt: 2 }}
//             onClick={handleProcessAudio}
//             disabled={processingLoading || selectedAudioIndex === null}
//           >
//             {processingLoading ? (
//               <CircularProgress size={20} color="inherit" />
//             ) : (
//               "🚀 Process Audio"
//             )}
//           </Button>
//         </DialogContent>
//       </Dialog>

//       <Dialog open={confirmDialogOpen} onClose={handleConfirmDialogClose}>
//         <DialogTitle>Confirm Action</DialogTitle>
//         <DialogContent>
//           <Typography>{confirmDialogMessage}</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleConfirmDialogClose} color="secondary" variant="outlined">
//             Cancel
//           </Button>
//           <Button onClick={handleConfirmDialogConfirm} color="primary" variant="contained">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>



//       {/* Transcript Modal */}
//       {/* <Dialog open={transcriptModalOpen} onClose={handleTranscriptClose} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           Transcript
//           <Button
//             onClick={handleTranscriptClose}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               textTransform: "none",
//             }}
//           >
//             CLOSE
//           </Button>
//         </DialogTitle>

//         <DialogContent sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: 200, // optional: gives space so it's visibly centered
//         }}>
//           {loadingTranscript ? (
//             <CircularProgress />
//           ) : (
//             <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
//               {transcript}
//             </Typography>
//           )}
//         </DialogContent>
//       </Dialog> */}
//       {/* Transcript Modal */}
//       <Dialog
//         open={transcriptModalOpen}
//         onClose={handleTranscriptClose}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle
//           sx={{
//             m: 0,
//             p: 2,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             backgroundColor: "#0B194A",
//             color: "white",
//           }}
//         >
//           <Typography variant="h6" sx={{ color: "white" }}>
//             Transcript
//           </Typography>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             {/* Search input */}
//             <TextField
//               size="small"
//               variant="outlined"
//               placeholder="Search..."
//               value={summarySearchQuery}
//               onChange={(e) => setSummarySearchQuery(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <FontAwesomeIcon
//                     icon={faMagnifyingGlass}
//                     style={{ marginRight: "8px", color: "#555" }}
//                   />
//                 ),
//               }}
//               sx={{
//                 backgroundColor: "white",
//                 borderRadius: "5px",
//                 width: "300px",
//               }}
//             />

//             {/* Close icon */}
//             <IconButton onClick={handleTranscriptClose} sx={{ color: "white" }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             maxHeight: "70vh",
//             overflowY: "auto",
//             whiteSpace: "pre-line",
//             mt: 1,
//           }}
//         >
//           {loadingTranscript ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <Typography variant="body1">
//               {transcript
//                 ? transcript.split(new RegExp(`(${summarySearchQuery})`, "gi")).map((part, i) =>
//                   part.toLowerCase() === summarySearchQuery.toLowerCase() ? (
//                     <span key={i} style={{ backgroundColor: "yellow" }}>
//                       {part}
//                     </span>
//                   ) : (
//                     part
//                   )
//                 )
//                 : "No transcript available."}
//             </Typography>
//           )}
//         </DialogContent>
//       </Dialog>


//       {/* ================================================================================== */}
//       {/* Audio Summary Modal */}

//       {/* <Dialog
//         open={summaryModalOpen}
//         onClose={handleSummaryClose}
//         fullWidth
//         maxWidth="lg"
//         PaperProps={{ style: { minHeight: "80vh" } }}
//       >
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h5" style={{ fontWeight: "bold" }}>
//               Audio Transcript Summary - {selectedSummaryEvent?.title}
//             </Typography>
//           </Box>

//           <Button
//             onClick={handleSummaryClose}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               textTransform: "none",
//             }}
//           >
//             CLOSE
//           </Button>
//         </DialogTitle>

//         <DialogContent>
//           {loadingSummary ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//               <CircularProgress />
//             </Box>
//           ) : filteredSummaryData.length === 0 ? (
//             <Box textAlign="center" py={4}>
//               <Typography variant="h6" color="textSecondary">
//                 No audio summaries found.
//               </Typography>
//             </Box>
//           ) : (
//             <Box>
//               {filteredSummaryData.map((summary, index) => (
//                 <Paper
//                   key={summary.uuid || index}
//                   elevation={2}
//                   style={{ marginBottom: "16px", padding: "16px" }}
//                 >
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
//                     <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
//                       {summary.name}
//                     </Typography>
//                     <Box display="flex" gap={1} flexWrap="wrap">
//                       {summary.categories && summary.categories.length > 0 ? (
//                         summary.categories.map((cat) => (
//                           <Box
//                             key={cat.id}
//                             style={{
//                               backgroundColor: getCategoryColor(cat.name),
//                               color: "white",
//                               padding: "4px 12px",
//                               borderRadius: "16px",
//                               fontSize: "12px",
//                               fontWeight: "bold"
//                             }}
//                           >
//                             {cat.name}
//                           </Box>
//                         ))
//                       ) : (
//                         <Box
//                           style={{
//                             backgroundColor: "#9E9E9E",
//                             color: "white",
//                             padding: "4px 12px",
//                             borderRadius: "16px",
//                             fontSize: "12px",
//                             fontWeight: "bold"
//                           }}
//                         >
//                           Uncategorized
//                         </Box>
//                       )}
//                     </Box>

//                   </Box>

//                   <Typography variant="body1" style={{ marginBottom: "16px", fontWeight: "500" }}>
//                     <strong>Short Summary:</strong> {summary.short_summary}
//                   </Typography>

//                   <Box style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "16px" }}>
//                     <Typography variant="body2" style={{ lineHeight: 1.6 }}>
//                       <strong>Long Summary:</strong> {summary.long_summary}
//                     </Typography>
//                   </Box>

//                   <Box display="flex" justifyContent="space-between" alignItems="center">
//                     <Typography variant="caption" color="textSecondary">
//                       {summary.state}, {summary.county}, {summary.municipality}
//                     </Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {new Date(summary.inserted_at).toLocaleDateString()}
//                     </Typography>
//                   </Box>
//                 </Paper>
//               ))}
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog> */}
//       <Dialog
//         open={summaryModalOpen}
//         onClose={handleSummaryClose}
//         fullWidth
//         maxWidth="lg"
//         PaperProps={{ style: { minHeight: "80vh" } }}
//       >
//         {/* Dialog Header */}
//         <DialogTitle
//           sx={{
//             m: 0,
//             p: 2,
//             backgroundColor: "#0B194A",
//             color: "white",
//             position: "relative", // needed for absolute positioning of close icon
//           }}
//         >
//           <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//             Audio Transcript Summary - {selectedSummaryEvent?.title}
//           </Typography>

//           {/* Close icon on top-right */}
//           <IconButton
//             onClick={handleSummaryClose}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               color: "white",
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         {/* Dialog Content */}
//         <DialogContent sx={{ pt: 3 }}>
//           {loadingSummary ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//               <CircularProgress />
//             </Box>
//           ) : filteredSummaryData.length === 0 ? (
//             <Box textAlign="center" py={4}>
//               <Typography variant="h6" color="textSecondary">
//                 No audio summaries found.
//               </Typography>
//             </Box>
//           ) : (
//             <Box>
//               {filteredSummaryData.map((summary, index) => (
//                 <Paper
//                   key={summary.uuid || index}
//                   elevation={2}
//                   sx={{ mb: 2, p: 2 }}
//                 >
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
//                     <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
//                       {summary.name}
//                     </Typography>

//                     <Box display="flex" gap={1} flexWrap="wrap">
//                       {summary.categories && summary.categories.length > 0
//                         ? summary.categories.map((cat) => (
//                           <Box
//                             key={cat.id}
//                             sx={{
//                               bgcolor: getCategoryColor(cat.name),
//                               color: "white",
//                               px: 2,
//                               py: 0.5,
//                               borderRadius: "16px",
//                               fontSize: "12px",
//                               fontWeight: "bold",
//                             }}
//                           >
//                             {cat.name}
//                           </Box>
//                         ))
//                         : (
//                           <Box
//                             sx={{
//                               bgcolor: "#9E9E9E",
//                               color: "white",
//                               px: 2,
//                               py: 0.5,
//                               borderRadius: "16px",
//                               fontSize: "12px",
//                               fontWeight: "bold",
//                             }}
//                           >
//                             Uncategorized
//                           </Box>
//                         )}
//                     </Box>
//                   </Box>

//                   <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
//                     <strong>Short Summary:</strong> {summary.short_summary}
//                   </Typography>

//                   <Box sx={{ maxHeight: "200px", overflowY: "auto", mb: 2 }}>
//                     <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
//                       <strong>Long Summary:</strong> {summary.long_summary}
//                     </Typography>
//                   </Box>

//                   <Box display="flex" justifyContent="space-between" alignItems="center">
//                     <Typography variant="caption" color="textSecondary">
//                       {summary.state}, {summary.county}, {summary.municipality}
//                     </Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {new Date(summary.inserted_at).toLocaleDateString()}
//                     </Typography>
//                   </Box>
//                 </Paper>
//               ))}
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>



//     </Box>
//   );
// };

// export default CaptureEvents;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BACKEND_BASE_URL } from "../config";
import { useLocation } from "react-router-dom";
import EventPropertiesModal from "../components/EventPropertiesModal";

const API_GET_EVENTS = `${BACKEND_BASE_URL}/api/capture/capture-events/`;
const API_DELETE_EVENT = (id) =>
  `${BACKEND_BASE_URL}/api/capture/capture-events/delete/${id}/`;

const CaptureEvents = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const municipalityId = params.get("municipalityId");
  const [eventSortKey, setEventSortKey] = useState("date_desc");
  const [startDate, setStartDate] = useState(""); // new
  const [endDate, setEndDate] = useState(""); // new
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [events, setEvents] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(null);

  const [propertiesModalOpen, setPropertiesModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);


  const getToken = () => localStorage.getItem("authToken");
  const getHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

  const fetchEvents = async () => {
    setLoadingEvents(true);
    try {
      let url = API_GET_EVENTS;
      if (municipalityId) {
        const separator = url.includes("?") ? "&" : "?";
        url = url + `${separator}municipality=${encodeURIComponent(municipalityId)}`;
      }
      const res = await fetch(url, { headers: getHeaders() });
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data)) setEvents(data);
        else if (Array.isArray(data.results)) setEvents(data.results);
        else if (Array.isArray(data.data)) setEvents(data.data);
        else setEvents([]);
      } else {
        toast.error("Failed to fetch events.");
        setEvents([]);
      }
    } catch (err) {
      console.error("Error fetching events:", err);
      toast.error("Error fetching events.");
      setEvents([]);
    } finally {
      setLoadingEvents(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    let tempEvents = [...events];

    // Filter by date range
    if (startDate || endDate) {
      tempEvents = tempEvents.filter((ev) => {
        console.log("Filtering event date:", ev);
        const evDate = new Date(ev.date);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        if (start && end) return evDate >= start && evDate <= end;
        if (start) return evDate >= start;
        if (end) return evDate <= end;
        return true;
      });
    }

    // Sort by date
    tempEvents.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      if (eventSortKey === "date_asc") return dateA - dateB;
      return dateB - dateA;
    });

    setFilteredEvents(tempEvents);
  }, [events, startDate, endDate, eventSortKey]);

  const handleDeleteConfirmed = async (id) => {
    setDeleteLoading(id);
    try {
      const res = await fetch(API_DELETE_EVENT(id), {
        method: "DELETE",
        headers: getHeaders(),
      });
      if (res.ok) {
        toast.success("Event deleted successfully.");
        setEvents((prev) => prev.filter((ev) => ev.id !== id));
      } else {
        toast.error("Failed to delete event.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error deleting event.");
    } finally {
      setDeleteLoading(null);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h5">Manage Capture</Typography>

        <Box display="flex" gap={2} alignItems="center">
          <TextField
            label="Start Date"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => {
              const newStartDate = e.target.value;
              if (endDate && new Date(newStartDate) > new Date(endDate)) {
                toast.error("Start date cannot be after end date.");
              } else {
                setStartDate(newStartDate);
              }
            }}
            inputProps={{
              max: endDate || undefined,
            }}
          />

          <TextField
            label="End Date"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => {
              const newEndDate = e.target.value;
              if (startDate && new Date(newEndDate) < new Date(startDate)) {
                toast.error("End date cannot be before start date.");
              } else {
                setEndDate(newEndDate);
              }
            }}
            inputProps={{
              min: startDate || undefined,
            }}
          />

          <FormControl size="small">
            <Select value={eventSortKey} onChange={(e) => setEventSortKey(e.target.value)}>
              <MenuItem value="date_desc">Date: Newest First</MenuItem>
              <MenuItem value="date_asc">Date: Oldest First</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {loadingEvents ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#1E2A78" }}>
              <TableRow>
                <TableCell sx={{ color: "#fff" }}>S.no</TableCell>
                <TableCell sx={{ color: "#fff" }}>Title</TableCell>
                <TableCell sx={{ color: "#fff" }}>Meeting Type</TableCell>
                <TableCell sx={{ color: "#fff" }}>Municipality</TableCell>
                <TableCell sx={{ color: "#fff" }}>Date</TableCell>
                <TableCell sx={{ color: "#fff" }}>Properties</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEvents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" style={{ fontStyle: "italic", color: "#666" }}>
                    No events available.
                  </TableCell>
                </TableRow>
              ) : (
                filteredEvents.map((ev, idx) => (
                  <TableRow key={ev.id}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{ev.title}</TableCell>
                    <TableCell>{ev.meeting_type_name || ev.meeting_type}</TableCell>
                    <TableCell>{ev.municipality_name}</TableCell>
                    <TableCell>
                      {ev.upload_date
                        ? new Date(ev.upload_date).toLocaleDateString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })
                        : ev.date
                          ? (() => {
                            // Parse as local date to avoid timezone conversion
                            // Date format from backend is YYYY-DD-MM
                            const [year, month,day ] = ev.date.split('-');
                            return `${month}/${day}/${year}`;
                          })()
                          : 'N/A'}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                          setSelectedEvent(ev);
                          setPropertiesModalOpen(true);
                        }}
                      >
                        Properties
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <EventPropertiesModal
        open={propertiesModalOpen}
        onClose={() => {
          setPropertiesModalOpen(false);
          setSelectedEvent(null);
          fetchEvents();
        }}
        event={selectedEvent}
        fetchEvents={fetchEvents}
        getToken={getToken}
      />
    </Box>
  );
};

export default CaptureEvents;
